import {
    browserDetect
} from '../deviceSpecific/_browserCheck';

const iOS7SearchFix = () => {
    if (navigator.userAgent.match(/iPad;.*CPU.*OS 7_\d/i)) {
        $('.site-search button.btn.btn-search').each(function() {
            $(this).attr("style", "margin-top: -2px;");
        });
    }
};

const iOSDisableKeyboardGo = () => {
    if ((browserDetect.OS == 'iPhone') || (browserDetect.OS == 'iPad')) {
        $('.qtyInput').keypress(function(e) {
            var code = (e.keyCode ? e.keyCode : e.which);
            if ((code == 13) || (code == 10)) {
                $(this).blur();
                return false;
            }
        });
    } else $(this).focus();
};

const iOSModalFix = () => {
    if (navigator.userAgent.match(/iPad/i)) {

        $('[data-browser-version="9"] .modal').css({
            position: 'absolute',
            paddingTop: $(window).scrollTop() + 'px',
            bottom: 'auto'
        });
        setTimeout(function() {
            $('[data-browser-version="9"] .modal-backdrop').css({
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: Math.max(
                    document.body.scrollHeight, document.documentElement.scrollHeight,
                    document.body.offsetHeight, document.documentElement.offsetHeight,
                    document.body.clientHeight, document.documentElement.clientHeight
                ) + 'px'
            });
        }, 0);
    }
};

const iOSPreventCache = () => {
    $(window).bind("pageshow", function(event) {
        if (event.originalEvent.persisted) {
            window.location.reload()
        }
    });
};

const iOSFixOrientationChangeZoom = () => {
	var ua = navigator.userAgent;
	if( !( /iPhone|iPad|iPod/.test( navigator.platform ) && /OS [1-5]_[0-9_]* like Mac OS X/i.test(ua) && ua.indexOf( "AppleWebKit" ) > -1 ) ){
		return;
	}

    var doc = w.document;

    if( !doc.querySelector ){ return; }

    var meta = doc.querySelector( "meta[name=viewport]" ),
        initialContent = meta && meta.getAttribute( "content" ),
        disabledZoom = initialContent + ",maximum-scale=1",
        enabledZoom = initialContent + ",maximum-scale=10",
        enabled = true,
		x, y, z, aig;

    if( !meta ){ return; }

    function restoreZoom(){
        meta.setAttribute( "content", enabledZoom );
        enabled = true;
    }

    function disableZoom(){
        meta.setAttribute( "content", disabledZoom );
        enabled = false;
    }

    function checkTilt( e ){
		aig = e.accelerationIncludingGravity;
		x = Math.abs( aig.x );
		y = Math.abs( aig.y );
		z = Math.abs( aig.z );

		// If portrait orientation and in one of the danger zones
        if( (!w.orientation || w.orientation === 180) && ( x > 7 || ( ( z > 6 && y < 8 || z < 8 && y > 6 ) && x > 5 ) ) ){
			if( enabled ){
				disableZoom();
			}
        }
		else if( !enabled ){
			restoreZoom();
        }
    }

	w.addEventListener( "orientationchange", restoreZoom, false );
	w.addEventListener( "devicemotion", checkTilt, false );
};

const iOS = () => {
    iOS7SearchFix();
    iOSDisableKeyboardGo();
    iOSModalFix();
    iOSFixOrientationChangeZoom();
    iOSPreventCache();
}

export {
  iOS,
  iOSModalFix
}
